/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationLabelPutRequest
 */
export interface ConversationLabelPutRequest {
    /**
     * Labels for the conversation. If one label contains : it means its a scoped label
     * @type {Array<string>}
     * @memberof ConversationLabelPutRequest
     */
    labels: Array<string>;
}

/**
 * Check if a given object implements the ConversationLabelPutRequest interface.
 */
export function instanceOfConversationLabelPutRequest(value: object): value is ConversationLabelPutRequest {
    if (!('labels' in value) || value['labels'] === undefined) return false;
    return true;
}

export function ConversationLabelPutRequestFromJSON(json: any): ConversationLabelPutRequest {
    return ConversationLabelPutRequestFromJSONTyped(json, false);
}

export function ConversationLabelPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationLabelPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'],
    };
}

export function ConversationLabelPutRequestToJSON(json: any): ConversationLabelPutRequest {
    return ConversationLabelPutRequestToJSONTyped(json, false);
}

export function ConversationLabelPutRequestToJSONTyped(value?: ConversationLabelPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'],
    };
}

